import React, { useState } from "react"
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom"

import "./styles/responsive.css"

import Cookies from "js-cookie"

import Login from "./LR/login"
import Reg from "./LR/reg"
import Logout from "./LR/logout"

import Food from "./comps/Foods"
import CartPage from "./comps/CartPage"
import Checkout from "./comps/Checkout"
import Orders from "./comps/Orders"
import Profile from "./comps/Profile"
import ProductDetails from "./comps/ProductDetails"
import CategoryPage from "./comps/CategoryPage"

import ProtectedRoute from "./LR/ProtectedRoute"
import Navbar from "./Navbar"

import Admin from "./comps/Admin"
import AdminProtectedRoute from "./comps/AdminProtectedRoute"
import AdminOrders from "./comps/Adminorder"
import AdminDashboard from "./comps/AdminDashboard"
import AdminRequirements from "./comps/AdminRequirements"
import FortyEightHours from "./comps/FortyEightHours"
import WeeklyItems from "./comps/WeeklyItems"

import Ct from "./Ct"

const App = () => {
  const token = JSON.parse(
    Cookies.get("logincrd") || "{}"
  )?.token

  const [isLogin, setIsLogin] = useState(!!token)

  const updfun = (value) => {
    setIsLogin(value)
  }

  return (
    <Ct.Provider value={{ isLogin, updfun }}>
      <BrowserRouter>
        <Navbar />

        <Routes>
          <Route path="/" element={<Food />} />

          <Route path="/login" element={<Login />} />

          <Route path="/reg" element={<Reg />} />

          <Route path="/logout" element={<Logout />} />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/cart"
            element={
              <ProtectedRoute>
                <CartPage />
              </ProtectedRoute>
            }
          />
          <Route path="/food/:id" element={<ProductDetails />} />
          <Route path="/category/:category" element={<CategoryPage />} />
          <Route
            path="/checkout"
            element={
              <ProtectedRoute>
                <Checkout />
              </ProtectedRoute>
            }
          />

          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <Orders />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin"
            element={
              <AdminProtectedRoute>
                <Admin />
              </AdminProtectedRoute>
            }
          />

          <Route
            path="/admin/orders"
            element={
              <AdminProtectedRoute>
                <AdminOrders />
              </AdminProtectedRoute>
            }
          />

          <Route
            path="/admin/dashboard"
            element={
              <AdminProtectedRoute>
                <AdminDashboard />
              </AdminProtectedRoute>
            }
          />
          <Route
  path="/admin/requirements"
  element={
    <AdminProtectedRoute>
      <AdminRequirements />
    </AdminProtectedRoute>
  }
/>

<Route
  path="/48-hours"
  element={<FortyEightHours />}
/>
<Route
  path="/weekly"
  element={<WeeklyItems />}
/>
        </Routes>
      </BrowserRouter>
    </Ct.Provider>
  )
}

export default App
